// import { REGEX } from 'consts';

const inputs = {
  name: {
    id: 'f',
    name: 'name',
    input: 'textField',
    label: 'dataModelList.form.name.label',
    placeholder: 'dataModelList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  project: {
    id: 'proyect_id',
    name: 'project',
    input: 'select',
    label: 'dataModelList.form.project.label',
    helperText: 'dataModelList.form.project.helperText',
  },
  additionalVariables: {
    id: 'txt',
    name: 'additionalVariables',
    label: 'dataModelList.form.variables.label',
    helperText: 'dataModelList.form.variables.helperText',
  },
  language: {
    id: 'language',
    name: 'baseUrl',
  }
};

export default inputs;
